import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import FieldInfoContainer from 'common/FieldInfoContainer';
import QuitFlowModalTrigger from 'common/QuitFlowModalTrigger';

const baseString = 'vra-script-flow-header';
const classString = classNames({
  [`${baseString}`]: true
});
const ScriptFlowHeader = ({
  isFinalAdvancedPlanting,
  onClickCancel,
  showOwnerName = false
}) => {
  const suffix = isFinalAdvancedPlanting ? '__final-advanced-planting' : '__body';
  return (
    <header className={classString}>
      <div className={baseString + suffix}>
        <QuitFlowModalTrigger onClickCancel={onClickCancel} />
        <FieldInfoContainer
          showOwnerName={showOwnerName}
          showScriptFlow={!showOwnerName}
        />
      </div>
    </header>
  );
};
ScriptFlowHeader.propTypes = {
  isFinalAdvancedPlanting: propTypes.bool,
  onClickCancel: propTypes.func.isRequired,
  showOwnerName: propTypes.bool
};
export default ScriptFlowHeader;
